import { connect } from "react-redux";
import { isWhiteLabel } from "app/reducers/brandSelector";
import ProductStickyHeader from "app/pages/FicheProduit/ProductStickyHeader/ProductStickyHeader";
import { bindActionCreators } from "redux";
import { toggleAsideMenu } from "app/pages/Header/menuActionCreators";
import { getFallbackRedirectUrl } from "app/reducers/partnerSelector";

const ProductStickyHeaderContainer = props => {
	return <ProductStickyHeader {...props} />;
};

const mapStateToProps = state => {
	return {
		showHamburger: isWhiteLabel(state),
		brand: state.brand.code,
		isAsideMenuOpened: state.menu.isAsideMenuOpened,
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			toggleAsideMenu,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductStickyHeaderContainer);
